import {
  type FC, memo, type ReactNode,
} from 'react';
import { type LatLng } from '../../../../_shared/types/latLng';
import { type MapObjectZIndex } from '../mapObject.types';
import { useAddCursorLabel } from '../mapShape/private/useAddCursorLabel';
import { MapObjectContextProvider } from '../private/mapObjectContext';
import { useMapObjectManager } from '../private/useMapObjectManager';
import { type MapCircleMetricInstance } from './mapCircleModel';

export type MapCircleMetricProps = {
  zIndex: MapObjectZIndex;
  circle: MapCircleMetricInstance;
  renderCircle?: (key: string, circle: MapCircleMetricInstance) => ReactNode;
  renderCenter?: (key: string, center: LatLng) => ReactNode;
  getCursorLabel?: (position: LatLng) => ({ text: string; angle?: number }) | null | undefined;
};

const MapCircleMetricContainer: FC<MapCircleMetricProps> = ({
  circle, zIndex, renderCircle, renderCenter, getCursorLabel,
}) => {

  const manager = useMapObjectManager();

  useAddCursorLabel({
    zIndex,
    getCursorLabel,
  });

  return (
    <MapObjectContextProvider value={{ manager, zIndex }}>
      {renderCircle?.(circle.id, circle)}
      {renderCenter?.(`${circle.id}-center`, {
        lat: circle.lat,
        lng: circle.lng,
      })}
    </MapObjectContextProvider>
  );
};

const pureComponent = memo(MapCircleMetricContainer);
export { pureComponent as MapCircleMetricContainer };
